import type { ReceivingOutcome } from "@redotech/redo-return-settings-common/receiving-outcome-config";

/** Failed GET must stay undefined; only a successful GET may store null. */
export function receivingOutcomeFromSettingsGet(
  getSucceeded: boolean,
  outcome: ReceivingOutcome | null,
): ReceivingOutcome | null | undefined {
  return getSucceeded ? outcome : undefined;
}

export function receivingOutcomeForSave(
  loaded: ReceivingOutcome | null | undefined,
  formOutcome: ReceivingOutcome | null,
): ReceivingOutcome | null | undefined {
  return loaded === undefined ? undefined : formOutcome;
}
